module.exports = __webpack_public_path__ + "img/report-1.a83c1dae.png";